import { LocationOn } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import { Grid } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export default function SuggestionSimulatorComponent({ suggestion }) {
    return (
        <Grid sx={{ color: "#337ab7", display: "flex" }}>
            <Grid>
                {suggestion.typeOfAction === "url_action" && <PublicIcon />}
                {suggestion.typeOfAction === "dialer_action" && <PhoneIcon />}
                {suggestion.typeOfAction === "view_location_query" && <LocationOn />}
                {suggestion.typeOfAction === "calendar_event" && <CalendarMonthIcon />}
            </Grid>
            <Grid paddingLeft={1}>{suggestion.suggestionText}</Grid>
        </Grid>
    );
}
